import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Typography, Button, ListItem, Hidden } from '@material-ui/core';
// import Checkbox from '@material-ui/core/Checkbox';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { isEmpty, isArray } from 'lodash';
import messages from 'aurora-translations';
import { getPropertType, keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMAlert } from 'aurora-components';
import PropertyBadge from 'aurora-section-components/ADGMPropertiesV2/PropertyList/Badge';

import styles from './styles';

function ADGMPropertyCard(props) {
  const {
    classes,
    intl,
    property,
    isLease,
    isOwnership,
    isMortgage,
    errors,
    errorActionText,
    errorActionHandler,
  } = props;
  const locale = localStorage.getItem('lang');

  const isBuilding = useMemo(() => property?.propertyType === 2, [property]);

  const isUnit = useMemo(() => property?.propertyType === 4, [property]);
  const isLand = useMemo(() => property?.propertyType === 1, [property]);

  const propertyTitle = useMemo(() => {
    if (isLand) return property?.plotAddress;
    if (isBuilding) return property?.buildingName;

    return [
      ...(property?.unitNumber ? [`${intl.formatMessage({ ...messages.Unit })} ${property?.unitNumber}`] : []),
      ...(property?.buildingNumber ? [property?.buildingNumber] : []),
    ].join(', ');
  }, [property]);

  const propertyDetails = useMemo(() => {
    return {
      municipality:
        locale === 'en'
          ? property?.municipalityNameEn || property?.municipalityNameAr
          : property?.municipalityNameAr || property?.municipalityNameEn,
      district:
        locale === 'en'
          ? property?.districtNameEn || property?.districtNameAr
          : property?.districtNameAr || property?.districtNameEn,
      community:
        locale === 'en'
          ? property?.communityNameEn || property?.communityNameAr
          : property?.communityNameAr || property?.communityNameEn,
      plot_number: property?.plotNumber,
      ...((((isOwnership || isMortgage) && isUnit) || (isLease && isBuilding)) && {
        building_name:
          locale === 'en'
            ? property?.buildingNameEn || property?.buildingNameAr
            : property?.buildingNameAr || property?.buildingNameEn,
      }),
      ...(isUnit && {
        unit_number: property?.unitNumber,
      }),
      ...(isLease &&
        (isBuilding || isUnit) && {
          prp_number: property?.buildingRegNumber,
        }),
      ...(isLease &&
        isUnit && {
          unt_number: property?.unitRegNum,
        }),
    };
  }, [property]);

  const propertyInfoList = useMemo(() => {
    const data = [];

    const landUseName =
      locale === 'en'
        ? property?.landUseNameEn || property?.landUseNameAr
        : property?.landUseNameAr || property?.landUseNameEn;

    const unitUsageName =
      locale === 'en'
        ? property?.unitUsageNameEn || property?.unitUsageNameAr
        : property?.unitUsageNameAr || property?.unitUsageNameEn;

    const buildingUsageName =
      locale === 'en'
        ? property?.buildingUsageNameEn || property?.buildingUsageNameAr
        : property?.buildingUsageNameAr || property?.buildingUsageNameEn;

    const ownerShipTypeName =
      locale === 'en'
        ? property?.ownerShipTypeNameEn || property?.ownerShipTypeNameAr
        : property?.ownerShipTypeNameAr || property?.ownerShipTypeNameEn;

    if (isLand && landUseName) data.push(landUseName);

    if (isUnit && (unitUsageName || landUseName)) data.push(unitUsageName || landUseName);

    if (isBuilding && buildingUsageName) data.push(buildingUsageName);

    if (isMortgage) data.push(property?.mortgageType);

    if ((isLand || (isMortgage && isUnit)) && property?.ownershipPercentage && ownerShipTypeName)
      data.push(`${property?.ownershipPercentage}% ${ownerShipTypeName}`);

    if (isBuilding && property?.unitCount)
      data.push(`${property?.unitCount} ${intl.formatMessage({ ...messages.units })}`);

    return data;
  }, [property]);

  return (
    <ListItem
      className={classNames(
        classes.listItemContainer,
        // {
        //   [classes.listItemContainerChecked]: isChecked,
        // },
        // {
        //   [classes.listItemContainerDisabled]: isDisabled,
        // },
      )}
      // disabled={isDisabled}
      // button
      // onClick={isDisabled ? null : () => onItemClick(property)}
    >
      <div className={classes.listItemHeader}>
        <div className={classes.listItemTitleWrapper}>
          <div className={classes.listItemTitle}>
            {/* <Checkbox
              edge='start'
              checked={isChecked}
              indeterminate={false}
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-labelledby': property.plotID }}
              classes={{
                root: classes.itemCheckbox,
                checked: classes.itemCheckboxChecked,
                indeterminate: classes.itemCheckboxIndeterminate,
              }}
            /> */}
            <Typography className={classes.titleText}>{propertyTitle}</Typography>
            <Hidden mdUp>
              <Typography className={classes.chip}>{keyEmptyCheck(getPropertType(property?.propertyType))}</Typography>
            </Hidden>
          </div>
          <PropertyBadge locale={locale} property={property} isOwnership={false} isLease={isLease} />
        </div>
        <div className={classes.propertyInfoList}>
          <Hidden smDown>
            <Typography className={classNames(classes.chip, classes.chipInline)}>
              {keyEmptyCheck(getPropertType(property?.propertyType))}
            </Typography>
          </Hidden>
          {propertyInfoList?.map(propertyInfo => (
            <div className={classes.propertyInfoContainer}>
              <span className={classes.propertyInfoIcon}>
                <svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4' fill='none'>
                  <circle cx='2' cy='2' r='2' fill='#CED1D6' />
                </svg>
              </span>
              <Typography className={classes.propertyInfoText}>{propertyInfo}</Typography>
            </div>
          ))}
        </div>
        <Hidden mdUp>
          <div className={classes.addressContainer}>
            <Typography className={classes.addressLabel}>{keyEmptyCheck('Address')}</Typography>
            <Typography className={classes.addressData}>
              {Object.values(propertyDetails)
                ?.filter(val => !!val)
                ?.join(', ')}
            </Typography>
          </div>
        </Hidden>
      </div>
      <Hidden smDown>
        <div className={classes.summaryContainer}>
          {Object.keys(propertyDetails)?.map(detailKey => (
            <div key={detailKey} className={classes.summaryItem}>
              <Typography className={classes.summaryItemLabel}>{keyEmptyCheck(detailKey)}</Typography>
              <Typography className={classes.summaryItemValue}>{propertyDetails[detailKey]}</Typography>
            </div>
          ))}
        </div>
      </Hidden>
      {isArray(errors) && !isEmpty(errors) && (
        <ADGMAlert className={classes.errorAlert} type='error'>
          <div className={classes.errorContainer}>
            <div className={classes.errorsList}>
              {errors?.map(error => (
                <Typography className={classes.errorText}>{keyEmptyCheck(error)}</Typography>
              ))}
            </div>
            {typeof errorActionHandler === 'function' && (
              <Button disableRipple className={classes.errorActionBtn} onClick={errorActionHandler}>
                {keyEmptyCheck(errorActionText)}
              </Button>
            )}
          </div>
        </ADGMAlert>
      )}
    </ListItem>
  );
}

ADGMPropertyCard.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  isLease: PropTypes.bool,
  isOwnership: PropTypes.bool,
  isMortgage: PropTypes.bool,
  errors: PropTypes.array,
  errorActionText: PropTypes.string,
  errorActionHandler: PropTypes.func,
};

ADGMPropertyCard.defaultProps = {
  isSelectable: true,
  isLease: false,
  isOwnership: false,
  isMortgage: false,
  errors: [],
  errorActionText: '',
  errorActionHandler: null,
};
export default withStyles(styles)(injectIntl(ADGMPropertyCard));
